import React from 'react';
import { useQuery } from 'react-query';
import { getClientTimeline } from '../../api/clientPortal';
import { useClientTheme } from '../../contexts/ClientThemeContext';
import { Spinner, ErrorBanner } from './ClientDashboardPage';

const MILESTONES = [
  { key: 'reservationOpen',  label: 'Reservation Open' },
  { key: 'reservationClose', label: 'Reservation Close' },
  { key: 'productionStart',  label: 'Production Start' },
  { key: 'delivery',         label: 'Delivery' },
];

const fmt = (d) => d ? new Date(d).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }) : 'Not set';

export default function ClientTimelinePage() {
  const { theme: T } = useClientTheme();
  const { data, isLoading, isError, error } = useQuery(['client-timeline'], getClientTimeline);
  const items = Array.isArray(data?.milestones) ? data.milestones : [];

  if (isLoading) return <Spinner T={T} />;
  if (isError) return <ErrorBanner T={T}>{error?.response?.data?.error || 'Failed to load timeline.'}</ErrorBanner>;

  return (
    <div>
      <div style={{ fontSize: 20, fontWeight: 700, color: T.text, marginBottom: 20 }}>Timeline</div>

      {items.length ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {items.map((item) => (
            <div key={item.campaignId} style={{ borderRadius: 10, border: `1px solid ${T.border}`, background: T.surface, padding: 18 }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: T.text, marginBottom: 16 }}>{item.name || 'Campaign'}</div>
              {MILESTONES.map(({ key, label }, i) => {
                const isSet = !!item[key];
                const isLast = i === MILESTONES.length - 1;
                return (
                  <div key={key} style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0, width: 16 }}>
                      <div style={{ width: 10, height: 10, borderRadius: '50%', flexShrink: 0, marginTop: 3, background: isSet ? T.gold : T.border, border: isSet ? 'none' : `1px solid ${T.border}` }} />
                      {!isLast && <div style={{ width: 1, flex: 1, minHeight: 20, background: T.border, marginTop: 4 }} />}
                    </div>
                    <div style={{ paddingBottom: isLast ? 0 : 16 }}>
                      <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: T.label, marginBottom: 2 }}>{label}</div>
                      <div style={{ fontSize: 14, fontWeight: 700, color: isSet ? T.text : T.textMuted }}>{fmt(item[key])}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      ) : (
        <div style={{ padding: '24px 0', textAlign: 'center', fontSize: 13, color: T.textMuted }}>No campaign milestones available yet.</div>
      )}
    </div>
  );
}
